import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Avatar } from "app/components/Avatar";
import { useFamilyModeSetting } from "hooks/useFamilyModeSetting";
import { useFamilyFriendlyFlag } from "hooks/useFeatureFlags";
import { useGetParentalControlsQuery } from "services/graphql";
import { DropdownMenu } from "app/components/Dropdown";
import { useGetUserProfilePhotoUrl } from "modules/selectors";
import { useGetUserProfile } from "hooks/User";
import { layout, LayoutProps } from "styled-system";
import { FamilyToggle } from "./FamilyToggle";
import { Links } from "./Links";

interface RootState {
  user: {
    public: {
      profile_pic: string;
    };
  };
  components: {
    Navbar: {
      height: number;
    };
  };
  auth: {
    isAnonymous: boolean;
    providerData: UserInfo[];
  };
}

// Could potentially pull firebase types: https://firebase.google.com/docs/reference/js/v8/firebase.UserInfo
interface UserInfo {
  photoURL: string;
}

const StyledButton = styled.button<LayoutProps>`
  padding: 0;
  border: 0;
  background: none;
  ${layout}
`;

export const DropdownAvatar = () => {
  const isAnonymous = useSelector(({ auth }: RootState) => auth.isAnonymous);
  const { isFamilyModeOn } = useFamilyModeSetting();
  const isFamilyFeatureEnabled = useFamilyFriendlyFlag();
  const { data: userData } = useGetParentalControlsQuery();
  const isParentalControlsEnabled = userData?.me?.parentalControls?.isEnabled;
  const { profileData } = useGetUserProfile();

  return (
    !isAnonymous && (
      <DropdownMenu
        align="end"
        direction="bottom"
        menuButton={
          <StyledButton type="button" height="32px" width="32px">
            <Avatar
              height="100%"
              width="100%"
              alt="Profile Avatar"
              src={profileData?.photoURL}
            />
          </StyledButton>
        }
      >
        {isFamilyFeatureEnabled && isParentalControlsEnabled ? (
          <>
            <FamilyToggle />
            {!isFamilyModeOn && (
              <Links
                isAnonymous={isAnonymous}
                username={profileData?.username}
              />
            )}
          </>
        ) : (
          <Links isAnonymous={isAnonymous} username={profileData?.username} />
        )}
      </DropdownMenu>
    )
  );
};
